import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { forceOffline, forceOnline } from "#/redux/resource/ApplicationSlice";

/**
 * Custom React hook to track the online/offline connection state of the browser.
 *
 * This hook listens to the browser's "online" and "offline" events to update the connection state in real-time.
 * It also provides functions to manually set the connection state, which can be useful for testing purposes.
 *
 * @returns {object} - An object containing the online status and functions to manually set the connection state.
 */
export default function useConnectionState() {
  const dispatch = useDispatch();
  const { isOnline } = useSelector((state) => state.application);

  return {
    get isOnline() {
      const connectionState = navigator.onLine;
      return connectionState;
    },
    get isOffline() {
      return !isOnline;
    },

    goOffline: () => dispatch(forceOffline()),
    goOnline: () => dispatch(forceOnline()),
  };
}
